<!-- 养护规则登记操作 -->
<template>
  <div>
    <subComponents ref="showSelectData"></subComponents>
    <el-dialog :visible.sync="dataActionBox.showStatus" :title="dataActionBox.boxTitle" center append-to-body top="2rem" width="80%">
      <div>
        <el-form label-width="130px" size="mini">
          <el-row>
            <el-col :span="24" v-for="(formOneValue,formOneKey) in formDataList.jurconfigform" :key="formOneKey" v-if="formOneValue.isShow==1">
              <el-form-item :label="formOneValue.showField" :hide-required-asterisk="formOneValue.isRequired == 1 ? true : false" label-width="240px">

                <!-- 停售数量 -->
                <el-input v-if="formOneValue.entityField == 'strategy'" v-model="sendDataInfo[formOneValue.entityField]"></el-input>

                <el-input v-else-if="formOneValue.entityField == 'ssmReason'" type="textarea" v-model="sendDataInfo[formOneValue.entityField]"></el-input>
                <el-input v-else type="number" :min="0" v-model.number="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength"></el-input>

              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dataActionBox.showStatus = false">取 消</el-button>
        <el-button type="primary" @click="sendDataAction" v-if="dataActionBox.actionType==0">保存</el-button>
        <el-button type="primary" @click="sendDataAction" v-if="dataActionBox.actionType==1">保存</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
      <SearchScheme ref="searchScheme" :id="seId" :smId="sendDataInfo.smId" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
    </el-dialog>
  </div>

</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../byComponents/SearchScheme.vue";
export default {
  name: "ypcxListConfigAction",
  props: [],
  //import引入的组件需要注入到对象中才能使用
  components: {
    SearchScheme,
  },
  data() {
    //这里存放数据
    return {
      selectDataTable: false,
      dataActionBox: {
        showStatus: false,
        boxTitle: "新增信息" || "编辑信息",
        actionType: 0, // 0新增，1修改
      },
      sendDataInfo: {
        jxqDays: "",
        keyPeriod: "",
        ordinaryPeriod: "",
        strategy: "",
        syDays: "",
      },
      formDataList: {},
      DialogVisible: false,
      seTitle: "",
      seWidth: "",
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    changeInputModel(val) {
      if (val != "" || val != undefined) {
        this.DialogVisible = false;

        if (this.seType == "ppamId") {
          this.sendDataInfo = val;
          this.sendDataInfo.spec = val.spec;
          this.sendDataInfo.bgmId = val.bgmId;
          this.sendDataInfo.bgmName = val.bgmName;
          this.sendDataInfo.sfiApayment = val.sfiApayment;
        }
      }
      // this.sendDataInfo.pisOrderDetail[this.seIndex].bgmName = val.bgmName
    },
    // 检索Id, 索引(表格中), 标识ppamId
    openSearch(sId, index, type) {
      this.DialogVisible = true;
      this.seId = sId;
      this.seIndex = index;
      this.seType = type;
    },
    getSeWidth(e) {
      this.seWidth = e + "%";
    },
    getWidth(e) {
      this.exWidth = e + "%";
    },
    getSearchName(e) {
      this.seTitle = e;
    },
    initActionBox() {
      for (let key in this.sendDataInfo) {
        this.sendDataInfo[key] = "";
      }
      this.sendDataInfo.rnmStdate = this.$moment().valueOf();
      this.dataActionBox.actionType = 0;
      this.dataActionBox.showStatus = false;
    },

    isShowData(name, value) {
      switch (name) {
        case "bgmId":
          var dataInfo = sessionStorage.getItem("selectBusinessGoodsEntryInfo");
          if (dataInfo) {
            dataInfo = JSON.parse(dataInfo);
            this.sendDataInfo.bgmId = dataInfo.bgmId;
            this.sendDataInfo.bgmName = dataInfo.bgmName;
          }

          break;

        default:
          this.sendDataInfo[name] = value;
      }
      this.sendDataInfo[name] = value;
    },

    openBox(cate, formData, oldData = "") {
      this.formDataList = formData;
      this.initActionBox();
      if (cate == 0) {
        this.dataActionBox.boxTitle = "新增养护规则";
      } else {
        this.dataActionBox.boxTitle = "编辑养护规则";
        var dataInfo = JSON.parse(JSON.stringify(oldData));
        this.sendDataInfo = dataInfo;
      }
      this.dataActionBox.actionType = cate;
      this.dataActionBox.showStatus = true;
    },

    async sendDataAction() {
      let sendData = JSON.parse(JSON.stringify(this.sendDataInfo));

        var responseData = await this.$http.storeShelfUpdateCuringSetting(sendData);
     
      if (responseData.status == 200) {
        this.initActionBox();
        this.$message({
          message: "操作成功",
          type: "success",
        });
        if (this.dataActionBox.actionType == 0) {
          this.$parent.setDataPageNumber(1);
        } else {
          this.$parent.getDataList();
        }
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>